import React from 'react';

import Layout from '../../components/Layout';
import Header from '../../components/Header';
import Navigation from '../../components/Navigation';
import { CustomerDetails } from '../../components/Customers';

import { useCustomerPage } from './hooks/useCustomerPage';

export const CustomerDetailsPageContent = () => {
  useCustomerPage();

  return (
    <Layout>
      <Layout.TopBar>
        <Header />
      </Layout.TopBar>
      <Layout.Body>
        <Layout.SideBar>
          <Navigation />
        </Layout.SideBar>
        <Layout.Content>
          <CustomerDetails />
        </Layout.Content>
      </Layout.Body>
    </Layout>
  );
};
